import { render, staticRenderFns } from "./RegrasAcesso.vue?vue&type=template&id=17b71b60&"
import script from "./RegrasAcesso.vue?vue&type=script&lang=js&"
export * from "./RegrasAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports